import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import t from '../../../i18n/t';
import { taskSelectors } from '@state/task';
import QuestionDialog from './QuestionDialog';
import CategoryTimeQuestion, { answerCategoryTime } from './CategoryTimeQuestion';

/**
 * The category question as an overlay, where no session popup asks it (askInPopup): after completing from the
 * sidebar, the Task List, the task's window, the calendar's tasks popup and prompts, or Auto-plan.
 */
const CategoryTimeDialog = () => {
  const dispatch = useDispatch();
  const { open, data } = useSelector(taskSelectors.getCategoryTimeDialog);

  if (!data || data.inPopup !== undefined) return null;
  const answer = (yes: boolean) => answerCategoryTime(dispatch, data, yes);

  return (
    <QuestionDialog open={open} onDismiss={() => answer(false)} dismissLabel={t.CATEGORY_TIME_NO}>
      {leave => <CategoryTimeQuestion data={data} withTask onAnswer={yes => leave(() => answer(yes))} />}
    </QuestionDialog>
  );
};

export default CategoryTimeDialog;
